import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { ImplementationDetailPage } from '#features/admin/implementations/implementation-detail-page'

export const Route = createFileRoute('/_app/admin/implementations/$id')({
  head: () => ({ meta: [{ title: 'Implementation details' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <ImplementationDetailPage implementationId={id} />
}
